var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgInfoLetterI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 10,
    className: "st1",
    width: 1.2,
    height: 7,
    fill: "#8F95AB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 7,
    className: "st1",
    width: 1.2,
    height: 1.5,
    fill: "#8F95AB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,2.4c-5.3,0-9.6,4.3-9.6,9.6c0,5.3,4.3,9.6,9.6,9.6c5.3,0,9.6-4.3,9.6-9.6C21.6,6.7,17.3,2.4,12,2.4z  M12,20.4c-4.6,0-8.4-3.8-8.4-8.4S7.4,3.6,12,3.6s8.4,3.8,8.4,8.4S16.6,20.4,12,20.4z",
    fill: "#8F95AB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLetterI);
export default __webpack_public_path__ + "static/media/InfoLetterI.6a68eb63.svg";
export { ForwardRef as ReactComponent };